import { useTrackingStore } from '@/stores/tracking';

export function handleAddToUnscheduledToasts({
  addToast,
  successfulCreates,
  invalidErrorChannels,
  hasServerError,
  mediaIds,
  channels,
}) {
  const trackingStore = useTrackingStore();
  if (invalidErrorChannels.size > 0) {
    addToast({
      message: `Invalid media for ${Array.from(invalidErrorChannels).join(', ')}`,
      severity: 'error',
    });
  } else if (hasServerError) {
    addToast({
      message: 'An unexpected error occurred',
      severity: 'error',
    });
  }

  if (successfulCreates > 0) {
    addToast({
      message: 'Media has been added to unscheduled posts.',
      severity: 'success',
    });
    trackingStore.track('Media added to Unscheduled Posts.', {
      mediaIds,
      channels,
    });
  }
}
